export default "__VITE_ASSET__DTXiUgqs__"